var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ik-data-table',{attrs:{"entity-name":_vm.$t('named_table_round_list'),"icon":'mdi-devices',"model":_vm.roundNameModel}})
}
var staticRenderFns = []

export { render, staticRenderFns }